const imageAudio = "_35sisrcjjm";
const image = "_35si3y2zij";

export { image, imageAudio };
import "./atom.image.style.linaria.module.css";
//# sourceMappingURL=atom.image.style.js.map
